<template>
	<div>
		<p v-if="useUgPolicy" class="responsible-gaming">
			This is a real-money gambling app. <br />Please gamble responsibly and only bet what you can afford.<br /> For more
			information, please view our Responsible Gaming Policy
			<a :href="`${env.responsibleGaming.link}`" target="_blank" class="session__form__link button no-bg link"
				style="
				color: var(--green);
				margin: 0;
				padding: 10px 0 0;
				text-align: left;
			">
				here
			</a>.
		</p>
		<p v-else-if="englishLocale.includes(env.locale)"
							class="account__section__desc responsible-gaming"
						>
							This is a real-money gambling app.<br /><br />
							Please gamble responsibly and only bet what you can afford.<br /><br />

							For gambling addiction help and support, please contact our
							Responsible Gambling Toll Free hotline at 0800 724835 or visit
							<a
								:href="env.responsibleGaming.website"
								target="_blank"
								class="session__form__link button no-bg link"
								style="
									color: var(--green);
									margin: 0;
									padding: 10px 0 0;
									text-align: left;
								"
								>The Responsible Gaming Website.</a
							><br /><br />

							For more information, please view our Responsible Gaming Policy
							<a
								:href="`${env.responsibleGaming.link}`"
								target="_blank"
								class="session__form__link button no-bg link"
								style="
									color: var(--green);
									margin: 0;
									padding: 10px 0 0;
									text-align: left;
								"
								>here.</a
							>
						</p>
		<p v-else-if="frenchLocale.includes(env.locale)"
							class="account__section__desc responsible-gaming"
						>
							Ceci est une application/site Web de jeu en argent réel<br /><br />
							Veuillez jouer de manière responsable et parier uniquement ce que vous pouvez vous permettre.<br /><br />

							Pour obtenir de l'aide et du soutien en matière de dépendance au jeu, veuillez nous contacter au 0900 490 490 <br /><br />

							Pour plus d’informations, veuillez consulter notre politique de jeu responsable
							<a
								:href="`${env.responsibleGaming.link}`"
								target="_blank"
								class="session__form__link button no-bg link"
								style="
									color: var(--green);
									margin: 0;
									padding: 10px 0 0;
									text-align: left;
								"
								>ICI</a>
						</p>
	</div>
</template>

<script>
export default {
	name: "ResponsibleGamingContent",
	computed: {
		locale() {
			let vm = this;
			let locale = vm.env.locale;

			return locale;
		},
		englishLocale(){
			return ['en-gh', 'en-ke', 'en-ug'];
		},
		frenchLocale(){
			return ['fr-cd'];
		},
		useUgPolicy() {
			return this.env.countryCode === 'UG'
		}
	},
};
</script>
<style>
	.responsible-gaming {
		width: 300px; 
		white-space: normal;
		word-break: break-word; 
	}
</style>